import './Icon.css';
import React from 'react';
import { IconProps } from './iconType';

export const TrashIcon: React.FC<IconProps> = ({
  size = 14,
  color,
  className,
}) => {
  return (
    <span
      className={['icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, color }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.5 1C5.22386 1 5 1.22386 5 1.5V3H9V1.5C9 1.22386 8.77614 1 8.5 1H5.5ZM10 3V1.5C10 0.671573 9.32843 0 8.5 0H5.5C4.67157 0 4 0.671573 4 1.5V3H2.5H0.5C0.223858 3 0 3.22386 0 3.5C0 3.77614 0.223858 4 0.5 4H2V12.5C2 13.3284 2.67157 14 3.5 14H10.5C11.3284 14 12 13.3284 12 12.5V4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H11.5H10ZM11 4H9.5H4.5H3V12.5C3 12.7761 3.22386 13 3.5 13H10.5C10.7761 13 11 12.7761 11 12.5V4ZM5.5 6C5.77614 6 6 6.22386 6 6.5V10.5C6 10.7761 5.77614 11 5.5 11C5.22386 11 5 10.7761 5 10.5V6.5C5 6.22386 5.22386 6 5.5 6ZM9 6.5C9 6.22386 8.77614 6 8.5 6C8.22386 6 8 6.22386 8 6.5V10.5C8 10.7761 8.22386 11 8.5 11C8.77614 11 9 10.7761 9 10.5V6.5Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};
